import RoomFacilitiesListComponent from './RoomFacilitiesList.component';
export default RoomFacilitiesListComponent;